'use client';

import { useState, useEffect } from 'react';
import { useTheme } from 'next-themes';

const ThemeToggle = () => {
    const [mounted, setMounted] = useState(false);
    const { resolvedTheme, setTheme } = useTheme();

    useEffect(() => {
        setMounted(true);
    }, []);

    // Reserve the button's space until the theme is known to avoid layout shift.
    if (!mounted) {
        return <span className="inline-block h-10 w-10" aria-hidden="true" />;
    }

    return (
        <button
            onClick={() => setTheme(resolvedTheme === 'dark' ? 'light' : 'dark')}
            className="flex h-10 w-10 items-center justify-center rounded-xl text-slate-600 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-gray-800 transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-customBlue"
            aria-label={resolvedTheme === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
        >
            {resolvedTheme === 'dark' ? (
                <i className="fas fa-sun text-base text-amber-400" aria-hidden="true"></i>
            ) : (
                <i className="fas fa-moon text-base" aria-hidden="true"></i>
            )}
        </button>
    );
};

export default ThemeToggle;
